export const flexPlus = {
  recipes: [
    {
      id: 'Rigatoni With Roasted Tomato Vodka Sauce',
      link: 'https://pamperedchef.widen.net/view/thumbnail/qvumugzpvd/post-recipe-rigatoni-with-roasted-tomato-vodka-sauce-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/qvumugzpvd/jpeg/post-recipe-rigatoni-with-roasted-tomato-vodka-sauce-steps.jpg?w=200&h=200&position=c&color=ffffffff&quality=80',
        alt: 'post-recipe-rigatoni-with-roasted-tomato-vodka-sauce-steps.jpg',
      },
    },
    {
      id: 'Vegan Black Bean Soup ',
      link: 'https://pamperedchef.widen.net/view/thumbnail/5jbywkoxyx/post-recipe-vegan-black-bean-soup-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/5jbywkoxyx/jpeg/post-recipe-vegan-black-bean-soup-steps.jpg?w=200&h=200&position=c&color=ffffffff&quality=80',
        alt: 'post-recipe-vegan-black-bean-soup-steps.jpg',
      },
    },
  ],
};
